// import React, { Component } from 'react';
// import { Bar } from 'react-chartjs-2';
// import { Divider } from 'react-md';
// import LoadingSpinner from './LoadingSpinner';

// const minStepSize = (value) => {
//   if (Math.floor(value) === value) {
//     return value;
//   }
// }
// export default class BarChartCustom extends Component {

//   chartOptions = (labelFormatter) => {
//     return {
//       barRoundness: 1,
//       legend: {
//         display: false
//       },
//       scales: {
//         xAxes: [
//           {
//             maxBarThickness: 50,
//             display: this.props.showxAxesLabel,

//           }
//         ], yAxes: [{
//           stacked: true,
//           ticks: {
//             beginAtZero: true,
//             callback: function (value, index, values) {
             
//               if (labelFormatter) {
//                 return labelFormatter(value);
//               }else{
//                 value = minStepSize(value);
//               }
//               return value;

//             }
//           }
//         }]
//       },
//       tooltips: {
//         callbacks: {
//           label: this.props.getBarLabel
//         }
//       }
//     }

//   };

//   render() {
//     if (this.props.loading)
//       return <LoadingSpinner />

//     const chartData = canvas => {
//       const ctx = canvas.getContext('2d');
//       var gradient = ctx.createLinearGradient(0, 0, 0, 300);
//       gradient.addColorStop(0, 'rgba(182,4,7,1)');
//       gradient.addColorStop(1, 'rgba(24,148,236,1)');
//       /***************/

//       return {
//         labels: this.props.label,
//         datasets: [
//           {
//             data: this.props.data,
//             hoverBackgroundColor: 'red',
//             borderWidth: 1,
//             backgroundColor: gradient,
//           }
//         ]
//       };
//     };



//     return (

//       <div>
//         <p style={{fontSize: "medium"}} className={this.props.graphTitleClass} >{this.props.title}</p>
//         <Divider className="fullWidth" />
//         <br />
//         <Bar data={chartData} options={this.chartOptions(this.props.labelFormatter)} />
//       </div>

//     );
//   }
// }



import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import LoadingSpinner from './LoadingSpinner';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Helper function - you'll need to implement this based on your original logic
const minStepSize = (value) => {
  if (Math.floor(value) === value) {
    return value;
  }
}

const BarChartCustom = ({
  loading,
  title,
  graphTitleClass,
  label,
  data,
  showxAxesLabel,
  labelFormatter,
  getBarLabel,
}) => {
  // Chart options configuration
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: getBarLabel || ((context) => {
            return `${context.dataset.label}: ${context.parsed.y}`;
          }),
        },
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        maxBarThickness: 50,
        display: false,
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: function (value, index, ticks) {
            if (labelFormatter) {
              return labelFormatter(value);
            } else {
              return minStepSize(value);
            }
          },
        },
      },
    },
    // Note: barRoundness is not a standard Chart.js option
    // You might need to use a plugin or borderRadius for rounded bars
    elements: {
      bar: {
        borderRadius: 4, // This provides rounded corners
      },
    },
  };

  // Chart data with gradient
  const chartData = {
    labels: label,
    datasets: [
      {
        data: data,
        hoverBackgroundColor: 'red',
        borderWidth: 1,
        backgroundColor: (context) => {
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, 300);
          gradient.addColorStop(0, 'rgba(182,4,7,1)');
          gradient.addColorStop(1, 'rgba(24,148,236,1)');
          return gradient;
        },
      },
    ],
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <p style={{ fontSize: 'medium' }} className={graphTitleClass}>
        {title}
      </p>
      <hr style={{ width: '100%', margin: '16px 0' }} />
      <br />
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default BarChartCustom;